export default "__VITE_ASSET__c69be772__"